import {closeSnackbar, enqueueSnackbar} from "notistack";

export const showSnackbar = (message, options = {}) => {
  const defaultOptions = {
    variant: "default",
    autoHideDuration: 3000,
    persist: false,
    action: null
  };

  enqueueSnackbar(message, {
    variant: options?.variant || defaultOptions.variant,
    autoHideDuration: options?.autoHideDuration || defaultOptions.autoHideDuration,
    persist: options?.persist || defaultOptions.persist,
    action: options?.action || defaultOptions.action,
    fields: options?.fields || [],
    warning: options?.warning || null,
    content: options?.copyData || null
  });
};

export const snackbar = {
  success: (message, options = {}) => showSnackbar(message, {...options, variant: "success"}),
  error: (message, options = {}) => showSnackbar(message, {...options, variant: "error"}),
  info: (message, options = {}) => showSnackbar(message, {...options, variant: "info"}),
  warning: (message, options = {}) => showSnackbar(message, {...options, variant: "warning"}),
  copy: (message, options = {}) => showSnackbar(message, {...options, variant: "copy"})
};

export const closeAllSnackbars = () => {
  closeSnackbar();
};
